import React, { useState, useCallback, useGlobal, setGlobal } from "reactn"

import { isEqual } from "lodash"
import { AddToCart } from "../add-to-cart"
import { RadioCard } from "../radioCard"
import { Box, VStack, Heading, HStack, useRadioGroup, Wrap, WrapItem, Square, Text, Spacer, Divider, } from "@chakra-ui/react"
import ProductAccordian from "./productAccordian"
import Price from "../price"
import { Link } from "gatsby"
import { Helmet } from "react-helmet"
import SustainabilityScore from "../sustainabilityScore"
import { IngmarsonCard } from "../card"
import ImageGenerator from "../imageGenerator"

export default function ProductInfo({ globalState, searchHit, isDesign = false, isGarment = true, itemLocation, collection, searchObjectID, searchQueryID, product, productMetafields, shipping, productInformation }) {
    const multiCSS = "linear-gradient(43deg, #ebf2ab 10%, #e7a0be 10%, #e7a0be 20%, #b4f0bc 20%, #b4f0bc 30%, #e7a0be 30%, #e7a0be 40%, #a7c7f9 40%, #a7c7f9 50%, #ebf2ab 50%, #ebf2ab 60%, #e7a0be 60%, #e7a0be 70%, #b4f0bc 70%, #b4f0bc 80%, #e7a0be 80%, #e7a0be 90%, #a7c7f9 90%, #a7c7f9 100%)"
    const {
        options,
        variants,
        fields,
        variants: [initialVariant],
        altcolors,
    } = product

    const isAlumni = fields.is_alumni
    const isDeleted = fields.is_deleted
    const hasVariants = variants.length > 1
    const altColourNodes = JSON.parse(altcolors)
    const hasAltColours = altColourNodes.length > 0
    const {
        price,
        sale_price,
        sustainability_score,
        on_sale,
        tags
    } = productMetafields

    console.log("PRODUCT META", productMetafields)
    const [client] = useGlobal('client')
    const [variantSelected, setVariantSelected] = useState(!hasVariants ? true : false)
    const [variant, setVariant] = useState({ ...initialVariant })
    const [quantity] = useState(1)
    const [designGUID, setDesignGUID] = useState(null)

    const productVariant =
        client && client.product && client.product.helpers.variantForOptions(product, variant) || variant

    const [available, setAvailable] = useState(isAlumni || isDeleted ? false :
        variant.availableForSale
    )

    if (!available && !isAlumni && !isDeleted && !initialVariant.availableForSale) {
        variants.forEach(thisVariant => {
            console.log("SETTING AVAILABLE", thisVariant)
            if (thisVariant.availableForSale) {
                setVariant({ ...thisVariant })
                setAvailable(true)
            }
        });
    }

    const [variantsAvailability, setVariantsAvailability] = useState(null)
    const checkAvailablity = useCallback(
        (productId) => {
            client && client.product && client.product.fetch(productId).then((fetchedProduct) => {
                console.log("FEDTCH", productId)
                const varientsAvailability = fetchedProduct.variants.reduce((acc, variant) => {
                    let { available, title } = variant;
                    return { ...acc, [title]: [...(acc[title] || []), available] };
                }, {});
                setVariantsAvailability(varientsAvailability)
                const result =
                    fetchedProduct?.variants.filter(
                        (variant) => variant.id === productVariant.storefrontId
                    ) ?? []
                if (result.length > 0) {
                    setAvailable(result[0].available)
                    setGlobal({ loading: false })
                }
            })
        },
        [productVariant.storefrontId, client && client.product]
    )

    const handleOptionChange = (value) => {
        if (value === "") {
            return
        }
        setVariantSelected(true)
        const currentOptions = {
            name: "Size",
            value: value
        }

        const selectedVariant = variants.find((variant) => {
            return isEqual([currentOptions], variant.selectedOptions)
        })
        setVariant({ ...selectedVariant })
    }

    React.useEffect(() => {
        window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
        window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })
    }, []);

    React.useEffect(() => {
        if (!isAlumni) {
            checkAvailablity(product.storefrontId)
        }
    }, [productVariant.storefrontId, checkAvailablity, product.storefrontId])

    const { getRootProps, getRadioProps } = useRadioGroup({
        name: "Size",
        defaultValue: !hasVariants ? options[0].values[0] : null,
        onChange: handleOptionChange
    })

    const amount = on_sale && sale_price && sale_price > 0 && price > sale_price ? sale_price : price
    console.log("ALT COLOURS", altColourNodes)
    return (

        <>
            <Helmet lang="en">
                <meta property="og:price:amount" content={amount} />
                <meta name="product:price:amount" content={amount} />
                <meta property="og:price:currency" content="GBP" />
                <meta name="product:price:currency" content="GBP" />
                <meta
                    property="og:availability"
                    content={tags && tags.includes('alumni') ? "https://schema.org/Discontinued" : "https://schema.org/InStock"}
                />
                <meta
                    name="product:availability"
                    content={tags && tags.includes('alumni') ? "https://schema.org/Discontinued" : "https://schema.org/InStock"}
                />
                <meta name="product:brand" content="INGMARSON" />
                <meta
                    property="og:condition"
                    content="https://schema.org/NewCondition"
                />
                <meta
                    name="product:condition"
                    content="https://schema.org/NewCondition"
                />
                <meta property="og:retailer_item_id" content={product.handle} />
                <meta name="product:retailer_item_id" content={product.handle} />
                <meta name="twitter:card" content="product" />
                <meta name="twitter:data1" content={amount} />
                <meta name="twitter:label1" content="Price" />
            </Helmet>

            <VStack width="100%" align={'start'}>
                <Heading as="h1" variant={'productHeading'}>{product.title}</Heading>
                <Price
                    id="productPrice"
                    price={price}
                    textAlign="left"
                    salePrice={sale_price}
                    onSale={on_sale}
                    saleActive={true} />
                {isDesign &&
                    <>
                        <Box width="100%">
                            <Text as="h2"
                                dangerouslySetInnerHTML={{ __html: `<div> ${product.descriptionHtml} </div>` }}>
                            </Text>
                        </Box>
                        <Divider />
                        <IngmarsonCard
                            id="designer"
                            variant="Grey"
                            // backgroundColor={'brandWhite.50'}
                            width="100%"
                            marginTop={0}
                            padding={0}>
                            <ImageGenerator setDesignGUID={setDesignGUID} globalState={globalState} isGarment={isGarment} />
                        </IngmarsonCard>
                        
                    </>
                }
                {sustainability_score &&
                    <SustainabilityScore score={sustainability_score} isDesign={isDesign} />
                }
                {!isDesign &&
                    <Box id="klarna-product">
                        <klarna-placement data-key={'credit-promotion-small'} data-locale={"en-GB"} data-purchase-amount={variant.price * 100}></klarna-placement>
                    </Box>
                }

                {hasAltColours &&
                    <Box id="altColorNodes">
                        <Box>
                            Available Colours
                        </Box>
                        <HStack>
                            {altColourNodes.map((altItem, i) => (
                                <Link
                                    key={`acn${i}`}
                                    to={altItem.url}
                                    aria-label={altItem.url}
                                >
                                    <Square size='30px'
                                        backgroundImage={altItem.is_multicolor ? multiCSS : ""} bg={altItem.color_name} borderWidth={'1px'} borderColor={'brandWhite.100'} />
                                </Link>
                            ))}
                        </HStack>
                    </Box>
                }
                <ProductAccordian product={product} productMetafields={productMetafields} shipping={shipping} productInformation={productInformation} isDesign={isDesign} />
                {/* <Box width="100%" pt={2} >Due to holidays, any orders placed will be shipped on the 12th October 2022.</Box> */}
                <Box width="100%" pt={2}>
                    <Wrap  >
                        {options.map(({ id, name, values }, index) => (
                            <Box key={`opt${index}`} id='options' display='contents'>
                                {values.map((value) => {
                                    const radio = getRadioProps({ value })
                                    return (
                                        <div key={`values${value}`} id='radiocards'>
                                            {value !== "Default Title" &&
                                                <WrapItem id='radioCard' >
                                                    <RadioCard key={value} {...radio}
                                                        isAvailable={isAlumni ? false : variantsAvailability && variantsAvailability[value] ? variantsAvailability[value][0] : true}
                                                        isDisabled={!(isAlumni ? false : variantsAvailability && variantsAvailability[value] ? variantsAvailability[value][0] : true)}>
                                                        {value}
                                                    </RadioCard>
                                                </WrapItem>
                                            }
                                        </div>
                                    )
                                })}
                            </Box>
                        ))
                        }
                        <WrapItem>

                            <AddToCart
                                product={product}
                                searchHit={searchHit}
                                searchObjectID={searchObjectID}
                                searchQueryID={searchQueryID}
                                itemLocation={itemLocation}
                                collection={collection}
                                productMetafields={productMetafields}
                                productVariant={variant}
                                variantId={variant.storefrontId}
                                quantity={quantity}
                                available={amount > 0 && available}
                                variantSelected={variantSelected}
                                isDesign={isDesign}
                                isGarment={isGarment}
                                designGUID={designGUID}
                                globalState={globalState}
                            />
                        </WrapItem>
                    </Wrap>
                </Box>
            </VStack>
        </>

    )
}

